"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicFormItemModule = /** @class */ (function () {
    function DynamicFormItemModule() {
    }
    return DynamicFormItemModule;
}());
exports.DynamicFormItemModule = DynamicFormItemModule;
